export default "__VITE_ASSET__CurOu7d5__"